import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, Form, Typography, Skeleton, Tag } from "antd";
import { useOrderDetails } from "../../../../../../contexts/OrderDetailsContext";
import { renderFieldContent, renderFieldLabel } from "./fieldRenderers";
import styles from "../index.scss";

const { Text } = Typography;

const DetailsSections = ({
  sections,
  loading,
  handleSave,
  handleCancel,
  form,
}) => {
  console.log("sections", sections);
  const { toggleEditMode, isFieldInEditMode, formData } = useOrderDetails();

  // If form is not provided, create a default one with getFieldValue that returns null
  const safeForm = form || {
    getFieldValue: () => null,
    setFieldsValue: () => {},
  };

  return (
    <Form form={safeForm} layout="vertical" onValuesChange={() => {}}>
      <div>
        <div className={styles.container}>
          {sections.map((section) => (
            <Card
              key={section.key}
              title={
                <div className={styles["details-sections__header"]}>
                  {loading ? (
                    <Skeleton.Input
                      className={styles["details-sections__header-skeleton"]}
                      active
                      size="small"
                    />
                  ) : (
                    <>
                      <Text strong>{section.title}</Text>
                      {section.tag && (
                        <Tag
                          color={section.tag.color}
                          className={styles["details-sections__header-tag"]}
                        >
                          {section.tag.text}
                        </Tag>
                      )}
                    </>
                  )}
                </div>
              }
              className={styles.section}
            >
              {section.fields.map((field, index) => (
                <Row
                  key={`${section.key}-${field.key}`}
                  align="middle"
                  className={`${styles["details-sections__row"]} ${
                    index % 2 === 0
                      ? styles["details-sections__row--even"]
                      : styles["details-sections__row--odd"]
                  }`}
                >
                  <Col span={10}>{renderFieldLabel(field.label, loading)}</Col>
                  <Col span={14}>
                    {renderFieldContent(
                      field,
                      safeForm,
                      section.key,
                      field.key,
                      {
                        loading,
                        isFieldInEditMode,
                        toggleEditMode,
                        handleSave,
                        handleCancel,
                        formData,
                      }
                    )}
                  </Col>
                </Row>
              ))}
            </Card>
          ))}
        </div>
      </div>
    </Form>
  );
};

DetailsSections.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
          editable: PropTypes.bool,
          isLink: PropTypes.bool,
          render: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.shape({
              node: PropTypes.node,
              onClick: PropTypes.func,
              props: PropTypes.object,
            }),
          ]),
        })
      ).isRequired,
      tag: PropTypes.object,
    })
  ),
  loading: PropTypes.bool,
  form: PropTypes.object,
  handleSave: PropTypes.func,
  handleCancel: PropTypes.func,
};

DetailsSections.defaultProps = {
  handleSave: () => {},
  handleCancel: () => {},
  form: null,
};

export default DetailsSections;
